import axios from "axios";
import { PARAMETER_STORE_MANAGER_REST_API_URL } from "../Common/Constant/API";
import { commonRequestHeaders } from "../Common/request/headers";

const getHeaders = () => {
  const token = localStorage.getItem("token");
  return {
    Authorization: `Bearer ${token}`,
    "vf-trace-transaction-id": crypto.randomUUID(),
    ...commonRequestHeaders(),
  };
};

export const retrieveParameters = async (parameterName) => {
  const response = await axios.get(PARAMETER_STORE_MANAGER_REST_API_URL, {
    params: { parameterName },
    headers: getHeaders(),
  });
  return response.data;
};

export const createParameter = async (parameterName, parameterValue) => {
  const response = await axios.post(
    `${PARAMETER_STORE_MANAGER_REST_API_URL}/create`,
    parameterValue,
    {
      params: { parameterName },
      headers: {
        ...getHeaders(),
        "Content-Type": "application/json",
      },
    },
  );
  return response.data;
};

export const updateParameter = async (parameterName, parameterValue) => {
  const response = await axios.post(
    `${PARAMETER_STORE_MANAGER_REST_API_URL}/update`,
    parameterValue,
    {
      params: { parameterName },
      headers: {
        ...getHeaders(),
        "Content-Type": "application/json",
      },
    },
  );
  return response.data;
};

export const rollbackParameter = async (parameterName) => {
  const response = await axios.get(
    `${PARAMETER_STORE_MANAGER_REST_API_URL}/roll-back`,
    {
      params: { parameterName },
      headers: getHeaders(),
    },
  );
  return response.data;
};
